import { categories, navItems } from "../../../mocks/hotNews";

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1320px] px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#home" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-eye-line text-lg"></i>
              </span>
              <span className="font-heading text-xl text-foreground-950">
                看料门<span className="text-primary-500">·</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              看料门聚焦全网公开热议话题，以吃瓜围观现场直击、前排热议实时更新的方式，带你第一时间掌握最新动态与讨论风向。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-rss-line"].map((ic) => (
                <a
                  key={ic}
                  href="#home"
                  aria-label="关注看料门"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${ic} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">快速入口</h4>
            <ul className="mt-4 space-y-2.5">
              {navItems.map((n) => (
                <li key={n.href}>
                  <a href={n.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900">围观栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.name}>
                  <a href="#columns" className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-4 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 看料门 KanLiaoMen · 前排吃瓜，围观实时热议</p>
          <div className="flex items-center gap-4 text-xs text-foreground-500">
            <a href="mailto:hello@kanliaomen.example" className="transition-colors hover:text-primary-600">
              联系编辑部
            </a>
            <span className="text-foreground-300">·</span>
            <span>内容仅整理公开信息，观点来自围观群众</span>
          </div>
        </div>
      </div>
    </footer>
  );
}